import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MemberStore } from '@ffx/app-store';

export function uniqueMemberEmailValidator(): ValidatorFn {
    const memberStore = inject(MemberStore);
    const allMembers$ = memberStore.currentProjectUsers;
    return (control: AbstractControl): ValidationErrors | null => {
        const allMembers = allMembers$();
        if (allMembers) {
            const emailExists = allMembers.some((member) => member.email === control.value && !member.editing);
            return emailExists ? { duplicateEmail: control.value } : null;
        }
        return null;
    };
}
